import classNames from 'classnames';

import { Model, StyledComponent } from 'types';

import { CloudinaryImage } from '../CloudinaryImage';

type ModelAvatarProps = {
  model: Model;
  size: number;
} & StyledComponent;

export const ModelAvatar: React.FC<ModelAvatarProps> = ({ model, className, size }) => (
  <div
    className={classNames('d-flex justify-content-center align-items-center', className)}
    style={{
      width: size,
      height: size
    }}
  >
    <CloudinaryImage
      src={model.images.length > 0 ? model.images[0].url : 'model_placeholder.png'}
      width={size * 0.7}
      height={size * 0.85}
      alt={`${model.displayName} Avatar Image`}
      quality={90}
    />
  </div>
);
